import { render, staticRenderFns } from "./SearchComponent.vue?vue&type=template&id=52ddb68a&"
import script from "./SearchComponent.vue?vue&type=script&lang=js&"
export * from "./SearchComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports